import getCollection from './getCollection'
import getObject from './getObject'
import createDoc from 'actions/base/createDoc'

const createSlot = async (slot) => createDoc(getCollection, getObject(slot))

export default createSlot
